import { useState } from 'react'
import { StarAvaliation } from '../Employee/StarAvaliation/StarAvaliation'

export function DropBox({ children, title, stars }) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<div className={`tw-my-3 tw-bg-white tw-rounded-md overflow-hidden ${isOpen ? 'tw-shadow-md' : ''}`} style={{ border: '2px solid', borderColor: isOpen ? '#7A6BE8' : 'white' }}>
			<button
				className={`border-0 tw-flex tw-justify-between tw-items-center tw-w-full tw-p-4 tw-py-3 tw-text-left ${isOpen ? 'tw-text-white tw-bg-purple' : 'tw-text-gray-800 tw-bg-white'} tw-font-medium tw-focus:outline-none`}
				onClick={() => setIsOpen(!isOpen)}
			>
				<span className={`tw-font-semibold `}>{title}</span>
				<div className='tw-flex tw-gap-8'>
					<StarAvaliation label='' value={stars} event={isOpen} />
					<svg className={`tw-mr-5 tw-w-5 tw-h-5 tw-transition ${isOpen ? 'tw-rotate-180' : 'tw-rotate-0'}`} fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
						<path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M19 9l-7 7-7-7'></path>
					</svg>
				</div>
			</button>
			<div className={`tw-w-full tw-overflow-hidden ${isOpen ? 'tw-max-h-full tw-animate-accordion-up' : 'tw-max-h-0 tw-animate-accordion-down'}`}>
				<div className='tw-p-4 '>{children}</div>
			</div>
		</div>
	)
}
